// Controls inside the shared calculator form card on /navamsa-chart and
// /hi/navamsa-chart: submit and the errors the card shows. Hindi is Devanagari
// (owner decision 2026-10-28, replacing the 2026-10-08 Hinglish rule), like the
// card's labels in BirthDetailsForm.i18n.ts; tests/hindi-register.test.ts
// guards the hi block (Devanagari) and the en block (no Devanagari). The card's
// heading is indexed page copy, Devanagari on /hi/ (owner, 2026-10-08), in
// ./_form-heading.ts; the page's hero, result and offer copy stay with the
// page.
export const NAVAMSA_CARD_COPY = {
  en: {
    submit: "Generate Navamsa chart",
    errorFallback: "Something went wrong. Please try again.",
    timeRequired: "Exact birth time is required to calculate D9 houses.",
    placeRequired: "Select a birth city from the suggestions to calculate its coordinates.",
  },
  hi: {
    submit: "नवांश चार्ट बनाएँ",
    errorFallback: "गणना नहीं हो पाई — कृपया दोबारा कोशिश करें।",
    timeRequired: "D9 भावों के लिए सही जन्म समय ज़रूरी है।",
    placeRequired: "सटीक निर्देशांक के लिए सुझावों में से जन्म स्थान चुनें।",
  },
} as const;
